export default __webpack_public_path__ + "static/media/2183.0644f166.png";